/** The app shell (`src/app/**`): header, bars, menus, footer, popovers, promos, route titles, error screen. */
export const fr = {
  /* Mobile top bar titles, by route (`handle.shell.top.title` in app/router.tsx) */
  'title.securePayment': 'Paiement sécurisé',
  'title.requestSent': 'Demande envoyée',
  'title.trips': 'Mes voyages',
  'title.favourites': 'Favoris',
  'title.profile': 'Profil',
  'title.messages': 'Messages',
  'title.reviews': 'Mes avis',
  'title.login': 'Connexion',
  'title.register': 'Inscription',
  'title.password': 'Mot de passe',
  'title.partner': 'Devenir partenaire',
  'title.experienceBooked': 'Expérience réservée',
  'title.about': 'À propos',
  'title.faq': 'Questions fréquentes',
  'title.terms': 'Conditions générales',
  'title.privacy': 'Confidentialité',
  'title.contact': 'Assistance',
  'title.blog': 'Journal',
  'title.article': 'Article',
  'title.agency': 'Agence',
  'title.notFound': 'Page introuvable',

  skipToContent: 'Aller au contenu',
  underConstruction: 'En construction',

  /* Header */
  securePayment: 'Paiement sécurisé · Stripe',
  agencyMode: 'Mode Agence',
  becomePartner: 'Devenir partenaire',
  preferences: 'Langue et devise',
  accountMenu: 'Menu du compte',
  universes: 'Univers',
  'messages.unread': { zero: 'Messages', one: 'Messages, {count} non lu', other: 'Messages, {count} non lus' },
  editSearch: 'Modifier la recherche',

  /* Bottom bar */
  'nav.label': 'Navigation principale',
  'nav.explore': 'Explorer',
  'nav.trips': 'Voyages',
  'nav.searchVehicle': 'Rechercher un véhicule',
  'nav.searchExperience': 'Rechercher une expérience',
  'nav.profileUnread': {
    zero: 'Profil',
    one: 'Profil, {count} message non lu',
    other: 'Profil, {count} messages non lus',
  },

  /* Account menu */
  'menu.label': 'Compte',
  'menu.upcoming': '{count} à venir',
  'menu.bookings': 'Mes réservations',
  'menu.agency': 'Agence',
  'menu.agencies': 'Agences',
  'menu.support': 'Assistance',
  'menu.signedOut': 'Vous êtes déconnecté.',
  'menu.signOut': 'Se déconnecter',

  /* Language and currency */
  'prefs.language': 'Langue',
  'prefs.currency': 'Devise',
  'prefs.MAD': 'Dirham',
  'prefs.EUR': 'Euro',
  'prefs.USD': 'Dollar US',
  'prefs.note':
    'Les prix sont établis en MAD. En EUR ou USD, le montant est indicatif et le taux est fixé au moment du paiement.',

  /* Footer */
  'footer.tagline': "Location de voitures, de motos et expériences auprès d'agences vérifiées au Maroc.",
  'footer.rent': 'Louer',
  'footer.account': 'Votre compte',
  'footer.about': 'À propos',
  'footer.faq': 'FAQ',
  'footer.blog': 'Blog',
  'footer.contact': 'Contact',
  'footer.copyright': '© {year} Cardnd · Agences vérifiées au Maroc',
  'footer.terms': 'Conditions générales',
  'footer.privacy': 'Confidentialité',
  'footer.prices': 'Prix en MAD · Paiement sécurisé par Stripe',
  'newsletter.label': 'Newsletter Cardnd',
  'newsletter.title': 'Offres et nouveautés par e-mail',
  'newsletter.field': 'Votre e-mail',
  'newsletter.placeholder': 'vous@exemple.com',
  'newsletter.submit': 'S’inscrire',
  'newsletter.required': 'Saisissez votre e-mail.',
  'newsletter.invalid': 'Adresse e-mail invalide.',
  'newsletter.done': 'Merci ! Vous recevrez nos offres et nouveautés. Désinscription en un clic dans chaque e-mail.',

  /* Promotional layers (P11) */
  'promo.payment.commission_only':
    'Payez une petite partie en ligne pour réserver. Le reste ? À l’agence, clés en main, contrat signé.',
  'promo.payment.full':
    'Payez votre location en ligne pour réserver : votre carte n’est débitée qu’à la confirmation de l’agence. À l’arrivée, il ne reste qu’à prendre les clés.',
  'promo.payment.label': 'Nouveau : paiement en ligne',
  'promo.payment.tag': 'Nouveau — paiement en ligne',
  'promo.payment.title': 'Votre voiture, réservée. <serif>Avant même votre arrivée.</serif>',
  'promo.payment.ok': 'J’ai compris',
  'promo.consent.label': 'Ne manquez aucune promotion',
  'promo.consent.title': 'Ne manquez aucune <serif>promotion.</serif>',
  'promo.consent.text':
    'Acceptez de recevoir nos offres exclusives et promotions par e-mail. Vous pouvez vous désinscrire à tout moment.',
  'promo.consent.accept': 'Oui, je veux recevoir les offres',
  'promo.consent.later': 'Peut-être plus tard',
  'promo.consent.privacy': 'Vos données sont protégées. Consultez notre <link>politique de confidentialité</link>.',
  'promo.app.label': 'Application Cardnd',
  'promo.app.title': 'L’appli Cardnd',
  'promo.app.text': 'Réservez plus vite, vos bons toujours sur vous.',
  'promo.app.open': 'Ouvrir',
  'promo.app.close': 'Fermer la bannière',

  /* Live chat: a message arriving outside the conversation */
  'chat.toast': '{name} : {text}',

  /* Last-resort error screen */
  'error.title': 'Un problème est survenu',
  'error.text': "Rechargez la page. Si le problème continue, contactez l'assistance.",
} as const;
